import React, { CSSProperties } from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export interface TooltipIconProps {
  title?: string
  className?: string
  style?: CSSProperties
}

export const TooltipIcon = (props?: SvgProps) => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    stroke="#D7D8DA"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M17 0.5C19.4853 0.5 21.5 2.51472 21.5 5L21.5 17C21.5 19.4853 19.4853 21.5 17 21.5L5 21.5C2.51472 21.5 0.5 19.4853 0.5 17L0.5 5C0.5 2.51472 2.51472 0.5 5 0.5L17 0.5Z"
      fill="white"
    />
    <path
      d="M17 0.5C19.4853 0.5 21.5 2.51472 21.5 5L21.5 17C21.5 19.4853 19.4853 21.5 17 21.5L5 21.5C2.51472 21.5 0.5 19.4853 0.5 17L0.5 5C0.5 2.51472 2.51472 0.5 5 0.5L17 0.5Z"
      fill="white"
    />
    <circle cx="11" cy="11" r="6" stroke="#D7D8DA" />
    <g clipPath="url(#clip0_3519_3314)">
      <path
        d="M18.0078 20.5C18.4952 20.9878 18.0229 21.4901 18.0049 21.5C17.9992 21.5001 17.9231 21.5 17.7764 21.5C16.1909 21.5003 14.5933 22.4122 13.3467 23.3936C12.733 23.8766 12.2245 24.361 11.8691 24.7246C11.6919 24.906 11.5533 25.0567 11.46 25.1611C11.4133 25.2133 11.3777 25.2542 11.3545 25.2812C11.3429 25.2947 11.3346 25.3051 11.3291 25.3115C11.3264 25.3147 11.3244 25.317 11.3232 25.3184L11.3223 25.3193L10.9492 25.7686L10.5625 25.3311L10.5615 25.3291C10.5602 25.3276 10.5577 25.3256 10.5547 25.3223C10.5488 25.3157 10.5396 25.3055 10.5273 25.292C10.5025 25.2647 10.4645 25.2234 10.415 25.1709C10.3161 25.0659 10.1694 24.9146 9.9834 24.7324C9.61066 24.3674 9.08072 23.8812 8.45215 23.3965C7.17101 22.4085 5.57521 21.5005 4.09766 21.5H3.99512C3.97892 21.4876 3.50645 20.9956 3.98438 20.501C3.98941 20.5008 3.99533 20.5 3.99707 20.5H18.0078Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3519_3314">
        <rect width="20" height="6" fill="white" transform="translate(1 21)" />
      </clipPath>
    </defs>
  </svg>
)
